var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReligiousItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      height: 512,
      width: 512
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0,
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    className: "",
    transform: "translate(0,0)",
    style: {}
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256.6 20.4c24.7 54-45.4 65.3-41 125.6l-43.4-39.6 14.8 67.2-65.8-23.7 39.5 56.3-69.79 3.3 55.69 35.4c-55.37 26.2-75.96-35-126.21 10.5 54.04-24.7 65.33 45.4 125.61 41l-39.6 43.4 67.2-14.8-23.7 65.8 56.3-39.5 3.3 69.7 35.4-55.6c26.2 55.6-35 75.6 10.5 126.6-24.7-54 45.4-66 41-126l43.4 40-14.8-67.6 65.8 23.7-39.5-56.3 69.8-3.3-55.7-35.4c55.4-26.2 76 35 126.2-10.5-54 24.7-65.3-45.4-125.5-41l39.5-43.4-67.2 14.8 23.7-65.8-56.3 39.5-3.3-69.8-35.4 55.7c-26.2-55.4 35-76-10.5-126.2zm-.6 134.1c56 0 101.5 45.5 101.5 101.5S312 357.5 256 357.5 154.5 312 154.5 256 200 154.5 256 154.5zm0 20.8c-44.5 0-80.7 36.2-80.7 80.7s36.2 80.7 80.7 80.7 80.7-36.2 80.7-80.7-36.2-80.7-80.7-80.7zm-35.6 33.6c18.1-.3 35.6 12.3 35.6 29.6V295l-18.6-6.5s29.5-70.3-17.7-70.3c-18.6 0-30.8 9.5-30.8 9.5 7.9-13 19.8-18.6 31.5-18.8zm-2.1 19.3c10.1-.1 19.9 4.6 22.9 17.2h-12.5c.3.7.5 1.5.5 2.3 0 4.6-5.7 8.3-12.8 8.3-7 0-12.7-3.7-12.7-8.3 0-.8.2-1.6.5-2.3h-12.5c0-8.2 10.7-15.4 22.2-16.9l4.4-.3zm75.4 0c13.1.1 26.6 8 26.6 17.2h-12.5c.3.7.5 1.5.5 2.3 0 4.6-5.7 8.3-12.7 8.3-7.1 0-12.8-3.7-12.8-8.3 0-.8.2-1.6.5-2.3h-12.5c2.7-11.7 11.4-16.6 20.8-17.1l2.1-.1zm-44.8 76.7c2.2 0 4.4.7 7.1 3 8.5-7.4 12.7 1.4 26.8 1.4 0 0-10.6 8.6-26.8 8.6-16.2 0-26.8-8.6-26.8-8.6 9.7 0 14.7-4.2 19.7-4.4z",
    fill: "#b45f06",
    fillOpacity: 1,
    clipPath: "url(#icon-bg)",
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReligiousItems);
export default __webpack_public_path__ + "static/media/religious-items.e3803056506f01ffd1a66b85521a966f.svg";
export { ForwardRef as ReactComponent };